import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getAppointmentDetailPrintById } from "../../../redux/actions/AppoinmentAction";
import { isLoadingAction } from "../../../Utils/helper";
import moment from "moment";
import { getExportAppoinmentExcelAction } from "../../../redux/actions/AppoinmentAction";
import { getRole } from "../../../Utils/types";

const AppointmentDetailsTemplate = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const [data, setData] = useState();
  const keyValuePairs = params?.ele.split("&");
  const paramDetails = {};
  for (const pair of keyValuePairs) {
    const [key, value] = pair.split("=");
    const decodedValue = value === "null" ? null : decodeURIComponent(value);
    paramDetails[key] = decodedValue;
  }

  useEffect(() => {
    if (paramDetails?.page) {
      isLoadingAction(true, dispatch);
      const resptemplate = dispatch(
        getExportAppoinmentExcelAction(paramDetails)
      );
      resptemplate?.then((res) => {
        if (res?.data?.status === true) {
          setData(
            getRole() === "ServiceProvider"
              ? res?.data?.results?.apointmentQueueList
              : res?.data?.results?.apointmentmanagementList
          );
          isLoadingAction(false, dispatch);
        } else {
          isLoadingAction(false, dispatch);
        }
      });
    } else {
      const resp = dispatch(
        getAppointmentDetailPrintById(JSON?.parse(params?.ele))
      );
      resp.then((res) => {
        if (res?.data?.status === true) {
          setData([res?.data?.results]);
          isLoadingAction(false, dispatch);
        } else {
          isLoadingAction(false, dispatch);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (data) {
      window.print();
    }
  }, [data]);

  return (
    <div className="book">
      {data?.map((ele, index) => {
        return (
          <div className="page" key={index}>
            <div className="subpage">
              <table>
                <tbody>
                  <tr>
                    <td>
                      <br />
                      <div>
                        Dear <strong>{ele?.providername}</strong>
                        ,<br />
                        <br />
                        Greetings from HealthAssure Team !<br />
                        <br />
                        <strong style={{ color: "#674EFC" }}>
                          Clicking of client photograph at the time of medicals
                          is a mandatory requirement.
                        </strong>
                        <br />
                        <br />
                        Appointment for
                        <strong>
                          {ele?.proposerName}, {ele?.caseNo}
                        </strong>
                        for <strong>{ele?.clientName} </strong>
                        has been scheduled at your centre on
                        <strong>
                          {paramDetails?.page
                            ? `${ele?.appointmentDate} ${ele?.appointmentTime}`
                            : moment(ele?.appointmentDateTime).format(
                                "Do MMM YYYY h:mm A"
                              )}
                        </strong>
                        . <br />
                        <br />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <br />
                      <table border="1px" className="table_detail_template">
                        <thead>
                          <tr>
                            <th>Proposal No.</th>
                            <td>{ele?.caseNo}</td>
                            <th>Priority</th>
                            <td>
                              {ele?.priority === null ? "-" : ele?.priority}
                            </td>
                          </tr>
                          <tr>
                            <th>Proposer Name</th>
                            <td>
                              {ele?.proposerName ? ele?.proposerName : "-"}
                            </td>
                            <th>Gender</th>
                            <td>{ele?.gender}</td>
                          </tr>
                          <tr>
                            <th>Package Name</th>
                            <td colSpan="5">
                              {ele?.packageName}
                            </td>
                          </tr>
                          <tr>
                            <th>Tests to be carried out</th>
                            <td colSpan="5">
                              {ele?.specialityName === null
                                ? ele?.tests
                                : ele?.specialityName} <br></br>
                                {ele?.additionalTest !== "" && <><span style={{fontWeight:"700",color:"#000000"}}>Additional Test : </span><span style={{fontWeight:"700",color:"#696666"}}>{ele?.additionalTest}</span></>}
                            </td>
                          </tr>
                          
                          <tr>
                            <th>Appointment Date</th>
                            <td>
                              {paramDetails?.page
                                ? `${ele?.appointmentDate} ${ele?.appointmentTime}`
                                : moment(ele?.appointmentDateTime).format(
                                    "Do MMM YYYY h:mm A"
                                  )}
                            </td>
                            <th>Mode of Visit</th>
                            <td>{ele?.visit}</td>
                          </tr>
                          <tr>
                            <th>Address for Visit</th>
                            <td colSpan="5">{ele?.address}</td>
                          </tr>
                          <tr>
                            <th>Female Technician Requested</th>
                            <td>{ele?.femaleTechnicianRequested}</td>
                            <th>Proposer Contact Number</th>
                            <td>
                              {ele?.mobileno}
                              <br />
                            </td>
                          </tr>
                          <tr>
                            <th>Pre-Requisites</th>
                            <td>
                              <ul
                                style={{
                                  listStyleType: "disc",
                                  paddingLeft: "10px",
                                }}
                              >
                                <li> Fasting - {ele?.preRequisites}</li>
                                <li> Copy of ID Proof - TRF/MTRF</li>
                              </ul>
                            </td>
                            <th>Mode of Payment</th>
                            <td>{ele?.modeOfPayment}</td>
                          </tr>
                        </thead>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AppointmentDetailsTemplate;
